module.exports = __webpack_public_path__ + "media/images/application/template/arrow-up-f9d40b3d21f967fe61ec71639a158435.png";